export const OficinasActionTypes = {
    API_RESPONSE_SUCCESS: '@@oficinas/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@oficinas/API_RESPONSE_ERROR',

    GET_OFICINA: '@@oficinas/GET_OFICINA',
    LIST_OFICINAS: '@@oficinas/LIST_OFICINAS',
    ADD_OFICINA: '@@oficinas/ADD_OFICINA',
    UPDATE_OFICINA: '@@oficinas/UPDATE_OFICINA',
    DELETE_OFICINA: '@@oficinas/DELETE_OFICINA',

    RESET: '@@oficinas/RESET',
};
